import { fetch } from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryNewss(
  {
    title, brandId, page, size, direction, sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/news`,
    method: 'get',
    params: {
      title,
      brandId,
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryNews(newsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/news/${newsId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  title
 * @param  subTitle
 * @param  postAt
 * @param  brandId
 * @param  coverPath
 * @param  topImagePath
 * @param  content
 * @param  contentImages
 * @param  tags
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addNews(
  {
    title,
    subTitle,
    postAt,
    brandId,
    coverPath,
    topImagePath,
    content,
    contentImages,
    link,
    tags,
    description, // 描述
    type,
    videoPath,
    articleType,
    shadePath,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/news`,
    method: 'post',
    data: {
      title,
      subTitle,
      postAt,
      brandId,
      coverPath,
      topImagePath,
      content,
      contentImages,
      link,
      tags,
      description, // 描述
      type,
      videoPath,
      articleType,
      shadePath,
    },
  });
}

/**
 * 更新
 * @param newsId
 * @param  title
 * @param  subTitle
 * @param  postAt
 * @param  brandId
 * @param  coverPath
 * @param  topImagePath
 * @param  content
 * @param  contentImages
 * @param  tags
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateNews(newsId, {
  title,
  subTitle,
  postAt,
  brandId,
  coverPath,
  topImagePath,
  content,
  contentImages,
  link,
  tags,
  description, // 描述
  type,
  videoPath,
  articleType,
  shadePath,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/news/${newsId}`,
    method: 'patch',
    data: {
      title,
      subTitle,
      postAt,
      brandId,
      coverPath,
      topImagePath,
      content,
      contentImages,
      link,
      tags,
      description, // 描述
      type,
      videoPath,
      articleType,
      shadePath
    },
  });
}

/**
 * 删除
 * @param newsId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteNews(newsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/news/${newsId}`,
    method: 'delete',
  });
}

export default {};
